import React, { useEffect } from "react";

export const useScript = (url, onload, onerror) => {
    useEffect(() => {
        // Avoid adding the script multiple times
        let existingScript = document.querySelector(`script[src="${url}"]`);
        if (existingScript) {
            if (onload) {
                // If the script is already present, call onload immediately
                onload();
            }
            return;
        }

        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.defer = true;

        if (onload) {
            script.onload = onload;
        }

        if (onerror) {
            script.onerror = onerror;
        }

        document.head.appendChild(script);

        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, [url, onload, onerror]);
};
